import React, { useState } from 'react'
import MobileNavbar from './MobileNavbar'

const Navbar = () => {

   const [isMenuOpen, setIsMenuOpen] = useState(false);

   return (
      <div className='navbar-container'>
         <MobileNavbar isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
      </div>
   )
}

export default Navbar
